"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { makeStyles } from "../../theming/index.js";
function getHintColor(theme, { color, valid }) {
    const palette = theme.palette(color).formGroup;
    switch (valid) {
        case true:
        case "valid": {
            return palette.hint.success.color;
        }
        case false:
        case "invalid": {
            return palette.hint.error.color;
        }
        default: {
            return palette.hint.color;
        }
    }
}
const useStyles = makeStyles()((theme, styles) => {
    const color = getHintColor(theme, styles);
    return {
        hint: {
            gridColumn: "input-start / input-end",
            marginTop: theme.spacing("xs"),
            fontSize: theme.typography.label.fontSize,
            color,
        },
    };
});
export const Hint = React.forwardRef(function Hint(_a, ref) {
    var { children, className, color = "text", valid } = _a, props = __rest(_a, ["children", "className", "color", "valid"]);
    const { classes, cx } = useStyles({ color, valid });
    return (_jsx("small", Object.assign({ ref: ref, className: cx(classes.hint, className), "data-component": "hint" }, props, { children: children })));
});
export default Hint;
//# sourceMappingURL=hint.js.map